module.exports = __webpack_public_path__ + "media/images/logo-74424228b5fd4808ad455fbd3fde47e7.png";